import { render } from "./documentError.vue?vue&type=template&id=2045c438&scoped=true"
import script from "./documentError.vue?vue&type=script&lang=js"
export * from "./documentError.vue?vue&type=script&lang=js"

import "./documentError.vue?vue&type=style&index=0&id=2045c438&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2045c438"]])

export default __exports__